<template>
  <div>
    <div class="big-box">
      <div class="top-cancel dis-flex">
        <div>
          <Icon
            type="md-close"
            size="22"
            color="#838383"
            @click="handleClose"
          />
        </div>
      </div>
      <div class="content-box">
        <div class="login-title font-bolder">Log In</div>
        <div class="content">
          <div class="input-content">
            <div class="input-box">
              <div class="input-text font-bolder">Username</div>
              <Input
                v-model.trim="userName"
                size="large"
                placeholder="Please enter your DChome account"
              />
            </div>
            <div class="input-box">
              <div class="input-text font-bolder">Password</div>
              <Input
                v-model.trim="passWord"
                type="password"
                size="large"
                placeholder="Please enter your password"
              />
            </div>
          </div>
          <div class="bottom-content">
            <div class="forget-password dis-flex">
              <div>
                <a
                  href="https://www.renogy-dchome.com/pc/#/forgot"
                  target="blank"
                  >Forgot Password</a
                >
              </div>
            </div>
            <div class="log-buttom font-bolder" @click="handleLogin">
              Log in
            </div>
            <div class="renogy dis-flex">
              <div class="font-bolder">New to Renogy Community?</div>
            </div>
            <div class="sign dis-flex">
              <div class="font-bolder">
                <a @click="handleRegister">Sign up</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dealCode } from "@/js/lib/dealCode";
import { showLoading, closeLoading } from "@/js/lib/utils";
import axios from "axios";
export default {
  data() {
    return {
      userName: "",
      passWord: ""
    };
  },
  methods: {
    handleRegister() {
      gtag("event", "register_dchome", {
        send_to: "G-VVXR7PJV6C",
        register_dchome: "1"
      });
      window.open("https://www.renogy-dchome.com/pc/#/register");
    },
    handleClose() {
      this.userName = "";
      this.passWord = "";
      this.$emit("handleClose");
    },
    handleLogin() {
      if (this.userName.replace(/\s+/g, "") === "") {
        this.$Message.error("Please enter your DChome account");
      } else if (this.passWord.replace(/\s+/g, "") === "") {
        this.$Message.error("Please enter your password");
      } else {
        showLoading();
        let config = {
          headers: { "Content-Type": "application/json" }
        }; //添加请求头
        axios
          .post(
            window.config.loginURL,
            {
              identifier: this.userName,
              credential: this.passWord,
              loginType: 0
            },
            config
          )
          .then(async res => {
            // console.log(res)
            let result = res.data;
            // console.log(result)
            closeLoading();
            if (result.success) {
              this.bindUserId(result.data.accessToken);
            } else {
              this.$Message.error(result.msg);
            }
          })
          .catch(e => {
            closeLoading();
            const { msg } = e.response.data;
            this.$Message.error(e.message + " " + msg);
          });
      }
    },
    // 绑定用户id
    async bindUserId(token) {
      let userInfo = await this.getUserInfo(token);
      gtag("event", "logged_in", {
        send_to: "G-VVXR7PJV6C",
        logged_in: `{username:${userInfo.userNickname},email:${userInfo.userEmail}}`
      });
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      let data = await this.handleBind(userInfo.userInnerId);
      // console.log(userInfo);return;
      this.$emit("loginSuccess", token);
    },
    handleBind(id) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(API.bindUserId, {
            userId: id,
            userinfo: localStorage.getItem("userInfo") || "{}"
          })
          .then(res => {
            dealCode({
              code: res.data.code,
              successCallback: async () => {
                resolve(true);
              },
              errorDeal: () => {
                reject(true);
              }
            });
          });
      });
    },
    getUserInfo(token) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(API.getLoginInfo, {
            token: token
          })
          .then(res => {
            dealCode({
              code: res.data.code,
              successCallback: async () => {
                let result = res.data.data;
                resolve(result.data);
              },
              errorDeal: () => {
                reject(true);
              }
            });
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped type="text/css">
.big-box {
  width: 35vw;
  height: 54vh;
  background: #fff;
  border-radius: 10px;
  margin: 0 auto;
  .top-cancel {
    height: 8%;
    width: 100%;
    flex-direction: row-reverse;
    align-items: center;
    padding: 0px 10px;
    > div {
      cursor: pointer;
    }
  }
  .content-box {
    height: 92%;
    padding-top: 10px;
    box-sizing: border-box;
    .login-title {
      text-align: center;
      color: #2b2b2b;
      font-weight: bold;
      font-size: 1.5vh;
      margin-bottom: 4vh;
    }
    .content {
      width: 70%;
      margin: 0 auto;
      .input-content {
        margin-bottom: 5vh;
        .input-text {
          color: #2b2b2b;
          font-size: 1.6vh;
          font-weight: 400;
          margin-bottom: 8px;
        }
        .input-box:not(:last-child) {
          margin-bottom: 2vh;
        }
        ::v-deep .ivu-input {
          border: 2px solid #cccccc;
          border-radius: 10px;
          height: 5vh;
        }
        ::v-deep .ivu-input:focus {
          border-color: #57a3f3;
        }
      }
      .bottom-content {
        .forget-password {
          margin-bottom: 8px;
          > div {
            cursor: pointer;
            color: #717070;
            font-size: 1.4vh;
          }
        }
        .log-buttom {
          cursor: pointer;
          font-weight: bold;
          font-size: 2vh;
          color: #fff;
          height: 5vh;
          line-height: 5vh;
          text-align: center;
          background: linear-gradient(0deg, #4d4d4d 0%, #727272 100%);
          box-shadow: 0px -2px 4px 0px rgba(98, 98, 98, 0.76);
          border-radius: 10px;
          margin-bottom: 2vh;
          &:hover {
            background: linear-gradient(0deg, #189ebd 0%, #17c0e7 100%);
            box-shadow: 0px -2px 3px 0px rgba(29, 181, 217, 0.74);
          }
        }
        .renogy {
          margin-bottom: 2.2vh;
          justify-content: center;
          > div {
            // cursor: pointer;
            font-size: 1.4vh;
            font-weight: 400;
            color: #a3a3a3;
          }
        }
        .sign {
          justify-content: center;
          > div {
            cursor: pointer;
            font-size: 1.6vh;
            font-weight: bold;
            color: #46c6e8;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginModal/LoginModal.vue